import { render, staticRenderFns } from "./Field.vue?vue&type=template&id=2a68dd08&scoped=true"
import script from "./Field.vue?vue&type=script&lang=js"
export * from "./Field.vue?vue&type=script&lang=js"
import style0 from "./Field.vue?vue&type=style&index=0&id=2a68dd08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a68dd08",
  null
  
)

export default component.exports